<template>
  <div
    class="m-wrap-new m-pc"
    :style="{
      background:
        extras1.formBg.colorOrBg == 'color'
          ? extras1.formBg.color
          : 'url(' + extras1.formBg.src + ')',
    }"
  >
    <div class="semianr-logo" v-if="extras1 && extras1.formLogo.display == '1'">
      <img
        :src="
          isSetting != '1'
            ? extras1.headerLogo && extras1.headerLogo.src
            : './images/logo_new.png'
        "
        alt=""
      />
    </div>
    <div class="seminar-info" v-if="isSetting != '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.textSetting.display == '1'"
        :class="extras1.BannerText.textAlign"
      >
        <div class="content">
          <div
            v-if="extras1.textSetting.subTitle !== 'hide'"
            class="seminar-title"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontColor
                  : '',
              'font-size':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            {{ getSubTitleText() }}
          </div>
          <div
            v-if="extras1.textSetting.title !== 'hide'"
            class="seminar-slogan"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontColor
                  : '',
              'font-size':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            {{ getTitleText() }}
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.timeTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ getTimeTitleText() }}
            </div>
            <div
              v-if="extras1.textSetting.time !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontColor
                    : '',
                'font-size':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.timeBgColor
                    ? extras1.textSetting.timeBgColor
                    : 'transparent',
              }"
            >
              {{ getTimeText() }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seminar-info" v-if="isSetting == '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.textSetting.display == '1'"
      >
        <div class="content">
          <div
            v-if="extras1.textSetting.subTitle !== 'hide'"
            class="seminar-title"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontColor
                  : '',
              'font-size':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            2023企业数字化峰会
          </div>
          <div
            v-if="extras1.textSetting.title !== 'hide'"
            class="seminar-slogan"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontColor
                  : '',
              'font-size':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            设计连接 新商业
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.timeTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ "会议时间" }}
            </div>
            <div
              v-if="extras1.textSetting.time !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontColor
                    : '',
                'font-size':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.timeBgColor
                    ? extras1.textSetting.timeBgColor
                    : 'transparent',
              }"
            >
              {{ "2023.12.12-12.13" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="field-area verify"
      :style="{
        background:
          extras1.formFieldBg.colorOrBg == 'color'
            ? extras1.formFieldBg.color
            : 'url(\'' + extras1.formFieldBg.src.replace(/'/g, '\\\'') + '\')',
      }"
    >
      <h4
        class="title"
        :class="extras1.verifyTitle.textAlign"
        :style="{
          'letter-spacing': extras1.verifyTitle.wordWidth + 'px',
          color:
            extras1.verifyTitle.verifyTitleTextStyle == 'custom'
              ? extras1.verifyTitle.fontColor
              : '',
          'font-size':
            extras1.verifyTitle.verifyTitleTextStyle == 'custom'
              ? extras1.verifyTitle.fontSize + 'px'
              : '',
          'font-style':
            extras1.verifyTitle.verifyTitleTextStyle == 'custom'
              ? extras1.verifyTitle.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            extras1.verifyTitle.verifyTitleTextStyle == 'custom'
              ? extras1.verifyTitle.fontWeight == 'on'
                ? '900'
                : ''
              : '',
        }"
        v-if="extras1.verifyTitle.display == 1"
      >
        {{
          extras1.verifyTitle.verifyTitleTextStyle == "custom"
            ? extras1.verifyTitle.title
            : "身份验证"
        }}
      </h4>
      <div class="tab-input">
        <!--字段上下结构-->
        <div v-if="extraItem.extras('formfield.model') == 'style1'">
          <div class="must style1">
            <div class="u-label">
              {{ identityPlaceholder || identityPlaceholderDefault }}
            </div>
            <a-input
              v-model="identity"
              class="verify-input"
              :class="{ err: error.identityText }"
              :placeholder="identityPlaceholder || identityPlaceholderDefault"
            ></a-input>
            <div v-if="isShowPhoneTips" style="color: #cacaca; font-size: 12px">
              手机号请填写区号，如86
            </div>
            <div class="u-reg-err-tips">{{ error.identityText }}</div>
          </div>
          <div
            class="must style1"
            :style="{
              display:
                extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
            }"
          >
            <div class="u-label">验证码</div>
            <div class="verify-con" style="display: flex">
              <a-input
                class="verify-input"
                v-model="code"
                :class="{ err: error.codeText }"
                placeholder="验证码"
              ></a-input>
              <a-button
                class="verify-button-back"
                type="primary"
                @click="sendCode()"
                :disabled="isRunning"
                >{{
                  isRunning ? initialNum + "s以后重新发送" : "发送验证码"
                }}</a-button
              >
            </div>
            <div class="u-reg-err-tips">{{ error.codeText }}</div>
          </div>
        </div>

        <!--字段内嵌结构-->
        <div v-if="extraItem.extras('formfield.model') == 'style2'">
          <div class="must style2">
            <div class="m-input-content">
              <div class="opacityText">
                {{ identityPlaceholder || identityPlaceholderDefault }}
              </div>
              <a-input
                v-model="identity"
                class="verify-input status-input"
                :class="{ err: error.identityText }"
              ></a-input>
              <div class="u-label" :class="{ moved: identity }">
                {{ identityPlaceholder || identityPlaceholderDefault }}
              </div>
            </div>
            <div v-if="isShowPhoneTips" style="color: #cacaca; font-size: 12px">
              手机号请填写区号，如86
            </div>
            <div class="u-reg-err-tips">{{ error.identityText }}</div>
          </div>
          <div
            class="must style2"
            :style="{
              display:
                extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
            }"
          >
            <div class="verify-con">
              <div class="opacityText">验证码</div>
              <a-input
                class="verify-input status-input"
                v-model="code"
                :class="{ err: error.codeText }"
              ></a-input>
              <div class="u-label" :class="{ moved: code }">验证码</div>
              <a
                class="verify-button"
                type="primary"
                @click="sendCode()"
                :disabled="isRunning"
                >{{
                  isRunning ? initialNum + "s以后重新发送" : "发送验证码"
                }}</a
              >
            </div>
            <div class="u-reg-err-tips pull-absolute">
              {{ error.codeText }}
            </div>
          </div>
        </div>

        <div class="verify-tip">
          <span
            class=""
            v-if="extras1.unSignButton && extras1.unSignButton.text != 'hide'"
            :style="{
              color:
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontColor
                  : '',
              'font-size':
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontSize + 'px'
                  : '',
              'font-style':
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
            >{{
              extras1.unSignButton.text2 == "custom"
                ? extras1.unSignButton.content
                : "尚未报名？"
            }}</span
          >
          <!--<a :href="$router.resolve(signUp).href" class="u-text-blue">点击报名</a>-->
          <router-link
            :to="signUp"
            v-if="extras1.unSignButton && extras1.unSignButton.text2 != 'hide'"
            class="go-sign"
            :style="{
              color:
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontColor2
                  : '',
              'font-size':
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontSize2 + 'px'
                  : '',
              'font-style':
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontTilt2 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontWeight2 == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
            >{{
              extras1.unSignButton.text2 == "custom"
                ? extras1.unSignButton.content
                : "点击报名"
            }}</router-link
          >
        </div>
        <a-button
          class="verify-submit"
          :style="{
            width: extras1.verifyButton.buttonWidth + '%',
            color:
              extras1.verifyButton.buttonTextStyle == 'custom'
                ? extras1.verifyButton.fontColor
                : '',
            'font-size':
              extras1.verifyButton.buttonTextStyle == 'custom'
                ? extras1.verifyButton.fontSize + 'px'
                : '',
            'font-style':
              extras1.verifyButton.buttonTextStyle == 'custom'
                ? extras1.verifyButton.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras1.verifyButton.buttonTextStyle == 'custom'
                ? extras1.verifyButton.fontWeight == 'on'
                  ? '900'
                  : ''
                : '',
          }"
          type="primary"
          @click="submitVerify()"
        >
          {{ extras1 | extra("verifyButton.text") }}</a-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import mixinConfig from "../../mixin/configNew.js";
import mixin from "../../mixin/form.js";
import mixinVerify from "../../mixin/verifyNew.js";
import mixinMeeting from "../../mixin/meetingNew.js";
export default {
  name: "PcVerify",
  mixins: [mixinConfig, mixin, mixinVerify, mixinMeeting],
  components: {},

  data() {
    return {
      platform: "pc",
    };
  },
  computed: {
    extras1() {
      return this.$store.state.extras;
    },
  },
  methods: {
    getSubTitleText() {
      const config = this.extras1.textSetting;
      return config.subTitleText ? config.subTitleText : "2023企业数字化峰会";
    },
    getTitleText() {
      const config = this.extras1.textSetting;
      return config.titleText
        ? config.titleText
        : this.seminarInfo.title || "设计连接 新商业";
    },
    getTimeTitleText() {
      const config = this.extras1.textSetting;
      return config.timeTitleText || config.text3 || "会议时间";
    },
    getTimeText() {
      const config = this.extras1.textSetting;
      return config.timeText
        ? config.timeText
        : this.handleTimeStamps(
            this.seminarInfo.startTime,
            this.seminarInfo.endTime
          );
    },
  },
};
</script>
